import { useEffect, useState, useRef } from 'react';
import { useMedia } from './useMedia';

export const useCartHeight = (padding: number): string => {
  const [height, setHeight] = useState('auto');
  const { isDesktop } = useMedia();
  const hasLoaded = useRef(false);
  const resizeHeight = (): void => {
    const element = document.getElementById(`gatsby-focus-wrapper`);
    if (element && isDesktop) {
      const { top } = element.getBoundingClientRect();
      const newHeight = window.innerHeight - top - padding;
      setHeight(`${newHeight}px`);
    } else {
      setHeight('auto');
    }
  };

  useEffect(() => {
    if (!hasLoaded.current) {
      resizeHeight();
      hasLoaded.current = true;
    }
    window.addEventListener('resize', resizeHeight);
    return (): void => {
      window.addEventListener('resize', resizeHeight);
    };
  }, [isDesktop, height]);

  return height;
};
